import { reportableEntityGQLFields, } from './reportableEntity.fields.js';
import { reportDataGQLFields } from './reportData.fields.js';
const BASIC_ENTITY_REPORT_FIELDS = {};
const ALL_ENTITY_REPORT_FIELDS = {
    entity: 'basic',
    data: 'basic',
};
export function entityReportGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_ENTITY_REPORT_FIELDS;
    if (fields === 'all')
        fields = ALL_ENTITY_REPORT_FIELDS;
    return `
    description
    endDate
    entityId
    entityType
    startDate
    tooltip
    ${fields.data
        ? `
      data {
        ${reportDataGQLFields(fields.data)}
      }
    `
        : ``}
    ${fields.entity
        ? `
      entity {
        ${reportableEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=entityReport.fields.js.map